import { connect } from "react-redux";
import { put, call, all, select, takeEvery } from "redux-saga/effects";
import { createAction } from "redux-delta";
import { asyncDelta } from "redux-delta/lib/dx/async";
import { fetchFactory, takeOnlyLeading } from "../saga";
import { callbackToBotSaga, closeWebviewSaga } from "../webview";
import { selectDailyTextsData } from "../dailytexts";
import { utcOffset } from "../../utils/time";
import { trackSaga } from "../mixpanel";
import { userApi, todosApi, dtsApi } from "../../api";

export const user = asyncDelta("user", { loading: true });

// SAGA WORKERS
export const fetchUser = createAction("FETCH_USER");
const fetchUserSaga = fetchFactory(user, ({ user_id }) =>
  userApi.fetchUser(user_id)
);

export const updateUser = createAction("UPDATE_USER");
const updateUserSaga = fetchFactory(user, ({ user_id, user }) =>
  userApi.updateUser(user_id, user).then(() => userApi.fetchUser(user_id))
);

export const confirmTimezone = createAction("CONFIRM_TIMEZONE");
function* confirmTimezoneSaga(action) {
  const { timezone } = action.payload;
  yield call(persistTimezoneSaga, action);
  yield call(callbackToBotSaga, "___TIMEZONE_CONFIRM___");
  yield call(closeWebviewSaga);
}

export const persistTimezone = createAction("PERSIST_TIMEZONE");
function* persistTimezoneSaga({ payload }) {
  const { days = [], hours = [] } = yield select(selectDailyTextsData);
  const { _id: user_id, timezone = 0 } = yield select(selectUserData);
  try {
    const reminder = (timezone - payload.timezone) * 1000 * 60 * 60;
    yield put(user.setLoading(true));
    yield call(userApi.updateUser, user_id, { timezone: payload.timezone });
    yield all([
      call(dtsApi.updateDailyTexts, { user_id, hours, days }),
      call(todosApi.updateReminders, user_id, { $inc: { reminder } })
    ]);
    yield todosApi.updateReminders(user_id, { $inc: { reminder } });
    yield put(fetchUser({ user_id }));
  } catch (e) {
    yield put(user.setFailure(e.message));
  }
}

function* setSystemTimezoneSaga() {
  const { timezone } = yield select(selectUserData);
  if (typeof timezone !== "number") {
    yield put(persistTimezone({ timezone: utcOffset(), from: "system" }));
  }
}

// SELECTORS
export const selectUser = ({ user = {} }) => user;
export const selectUserData = ({ user = {} }) => user.data || {};

// CONNECTORS

export const withUser = connect(
  selectUser,
  { fetchUser, updateUser, persistTimezone }
);

export const withUserData = connect(
  selectUserData,
  { fetchUser, updateUser, persistTimezone }
);

// SAGA WATCHER
export default function* userSaga() {
  yield takeOnlyLeading(user.setSuccess.type, setSystemTimezoneSaga);

  yield takeEvery(confirmTimezone.type, confirmTimezoneSaga);
  yield takeOnlyLeading(
    confirmTimezone.type,
    trackSaga("Settings Webview Edit Timezone")
  );

  yield takeEvery(persistTimezone.type, persistTimezoneSaga);
  yield takeOnlyLeading(
    persistTimezone.type,
    trackSaga("Settings Webview Edit Timezone")
  );

  yield takeEvery(fetchUser.type, fetchUserSaga);
  yield takeEvery(updateUser.type, updateUserSaga);
}



// WEBPACK FOOTER //
// ./src/store/user/index.js